// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import {ScaleLinear} from 'd3';

import {PrimerAssemblyMismatch} from 'components/PrimerAssemblyMismatches';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {Sequence} from 'components/Sequence';
import LayeredView, {LayeredViewOptions} from 'molbio/maps/linear/LayeredView';
import {PrimerAssemblyMismatch as PrimerAssemblyMismatchLayout} from 'molbio/maps/linear/LinearLayout';
import Range from 'molbio/maps/selectables/Range';

export interface PrimerAssemblyMismatchViewOptions extends LayeredViewOptions {
  range: Range | null;
}

class PrimerAssemblyMismatchView extends LayeredView<Sequence, PrimerAssemblyMismatch> {
  layout!: PrimerAssemblyMismatchLayout;

  static initClass(): void {
    this.prototype.className = 'primerAssemblyMismatches';
  }

  initialize(options: PrimerAssemblyMismatchViewOptions): void {
    super.initialize(options);
    this.layout = this.model.get('layout').PrimerAssemblyMismatch;
  }

  registerListeners(): void {
    super.registerListeners();
    this.listenTo(this.layout.get('DNA'), 'change:complement', function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
    this.listenTo(this.sequence.primerAssemblyMismatches(), 'reset', function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
  }

  shouldShow(): boolean {
    return true;
  }

  getData(start: number, end: number): Array<PrimerAssemblyMismatch> {
    return this.sequence.primerAssemblyMismatches().slice(start, end);
  }

  layerFill(_: PrimerAssemblyMismatch): string {
    return '#84B0DC';
  }

  layerFillOpacity(_: PrimerAssemblyMismatch): number {
    return 0.4;
  }

  getLayout(): PrimerAssemblyMismatchLayout {
    return this.model.get('layout').PrimerAssemblyMismatch;
  }

  boxHeight(): number {
    return 0;
  }

  isShown(): boolean {
    return true;
  }

  contextMenuOptions(): Array<string> {
    return selectioncontextmenu.getSelectionMenu();
  }

  contextMenuData(_: PrimerAssemblyMismatch): {} {
    return {};
  }

  setLayers(): Array<PrimerAssemblyMismatch> {
    return Array.from(this.data).map(
      // Backbone.Model.set is not generic; it is instead typed as returning base Model
      // in any case I think this is unused ¯\_(ツ)_/¯
      (model: PrimerAssemblyMismatch) => model.set('linearLayer', 0) as PrimerAssemblyMismatch
    );
  }

  makeLayerPiece(enter: d3.Selection<SVGElement, PrimerAssemblyMismatch, d3.BaseType, unknown>): void {
    // Call on an enter selector.
    enter.classed('layer', true);
    enter.append('svg:rect').classed('layer-fill', true);
  }

  rerenderSingle(
    el: SVGElement,
    start: number,
    end: number,
    dx: number,
    dy: number,
    mismatch: PrimerAssemblyMismatch,
    xx: number,
    yy: number,
    xTransform: ScaleLinear<number, number>,
    yTransform: ScaleLinear<number, number>
  ): void {
    d3.select(el)
      .select('.layer-fill')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', dx)
      .attr('height', dy)
      .attr('fill', (d: PrimerAssemblyMismatch) => this.layerFill(d))
      .attr('fill-opacity', (d: PrimerAssemblyMismatch) => this.layerFillOpacity(d));
  }

  clickAction(e: Event, d: PrimerAssemblyMismatch): void {
    d.click(this.model.get('sequence'));
  }
}
PrimerAssemblyMismatchView.initClass();

export default PrimerAssemblyMismatchView;
